import { render, staticRenderFns } from "./EncargoSetting.vue?vue&type=template&id=6f518a4a"
import script from "./EncargoSetting.vue?vue&type=script&lang=js"
export * from "./EncargoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports